import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { Claims } from "src/app/_models/common/claims";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { EssentialPackService } from "src/app/_services/essential-pack/essential-pack.service";
import { OrgBasicFunctionSubscriptionService } from "src/app/_services/billing-pricing/Org-BasicFunction-Subscription.service";

import { ICONS } from "src/app/_helpers/icons.constants";
import { ModalComponent } from "src/app/shared/design-system/modal/modal.component";
import { ModalConfig } from "src/app/shared/design-system/modal/modal.modal";
import { ButtonComponent } from "src/app/shared/design-system/button/button.component";
import { InfoTextConfig } from "../../shared/design-system/info-text/info-text.modal";

@Component({
  selector: "essential-pack-startup",
  templateUrl: "./essential-pack-startup.component.html",
  standalone: true,
  imports: [
    TranslateModule,
    ModalComponent,
    ButtonComponent
  ]
})
export class EssentialPackStartupComponent implements OnInit {

  @Output() continueEvent = new EventEmitter<boolean>();

  claims!: Claims;
  basicFunctionTrialDays: number = 0;

  showStartupPopup = true;
  startupModalConfig!: ModalConfig;
  continueButtonConfig!: any;
  stepInfoConfig!: InfoTextConfig;

  public ICONS = ICONS;

  constructor(
    private claimsService: ClaimsService,
    private toastr: ToastrService,
    private essentialPackService: EssentialPackService,
    private translate: TranslateService,
    private orgBasicFunctionSubscriptionService: OrgBasicFunctionSubscriptionService
  ) {
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit(): void {
    this.fnStartupModalControls();
    this.fnGetOrgBasicFunctionSubscriptionTrialDetails();
  }

  fnStartupModalControls(): void {
    this.startupModalConfig = {
      visible: this.showStartupPopup,
      hiddenCloseIcon: true,
      size: "md",
    };

    this.continueButtonConfig = {
      id:"btnContinue",
      label: `${this.translate.instant('new_onb_startup_start_button')}`,
      color: "primary",
      size: "lg",
      block: true
    };

    this.stepInfoConfig = {
      iconSrc: this.ICONS.CHECK,
      iconClass: 'icon-success',
    };
  }

  fnOpenStartupModal(): void {
    this.showStartupPopup = true;
    this.fnStartupModalControls();
  }

  fnCloseStartupModal(): void {
    this.showStartupPopup = false;
     this.startupModalConfig = {
        ...this.startupModalConfig,
        visible: this.showStartupPopup
      };
  }

  fnGetOrgBasicFunctionSubscriptionTrialDetails(): void {
    this.orgBasicFunctionSubscriptionService
      .GetOrgBasicFunctionSubscriptionTrialDetails(this.claims?.OrgId)
      .subscribe((res: any) => {
        if (res?.responseInfo) {
          this.basicFunctionTrialDays = res.responseInfo.basicFunctionTrialDays;
          this.fnOpenStartupModal();
        }
      });
  }

  fnOnContinue(): void {
    this.continueEvent.emit(true);
    this.fnCloseStartupModal();
  }
}